import React, { FC } from "react";
import { Loader } from "../../atoms/Loader";
import { CalendarEventLoader } from "../../organisms/CalendarEventLoader";
import { Table } from "../../organisms/Table";
import { HeaderText, LoaderWrapper, TableWrapper, Wrapper } from "./elements";

type Props = {
  tableData: any[];
  columns: any[];
  setRowRecord?: any;
  isLoading?: boolean;
  isChecking: boolean;
  onScroll?: any;
  updateApplicantRequest?: any;
  onChange?: (pagination: any, filters: any) => void;
  total: number;
  currentPage?: number | undefined;
};

const JobOffer: FC<Props> = ({
  tableData,
  columns,
  setRowRecord,
  isLoading,
  isChecking,
  onScroll,
  updateApplicantRequest,
  onChange,
  total,
  currentPage,
}) => {
  return (
    <Wrapper onScroll={onScroll}>
      {isChecking ||
      (updateApplicantRequest?.isLoading &&
      updateApplicantRequest?.request &&
      updateApplicantRequest?.request.data?.interviewers &&
      Object.getOwnPropertyNames(updateApplicantRequest?.request?.data)
        .length > 1) ? (
        <LoaderWrapper>
          <CalendarEventLoader
            isChecking={isChecking}
            isUpdateInterviewers={false}
          />
          <Loader />
        </LoaderWrapper>
      ) : (
        <>
          <HeaderText>Job Offer</HeaderText>
          <TableWrapper>
            <Table
              isLoading={isLoading}
              tableData={tableData}
              columns={columns}
              rowRecord={setRowRecord}
              onChange={onChange}
              totalItems={total}
              current={currentPage}
            />
          </TableWrapper>
        </>
      )}
    </Wrapper>
  );
};

export default JobOffer;
